"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignIfLegacy = alignIfLegacy;
exports.removeUndefinedKeys = removeUndefinedKeys;
exports.constantCase = constantCase;
exports.split = split;
const constants_js_1 = require("./constants.js");
function alignIfLegacy(url, type) {
    const { protocol } = new URL(url);
    return protocol === `${type}:` ? `${constants_js_1.WIX_PROTOCOL}${url}` : url;
}
function removeUndefinedKeys(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
}
function constantCase(input) {
    return split(input)
        .map((part) => part.toLocaleUpperCase())
        .join('_');
}
const SPLIT_LOWER_UPPER_RE = /([\p{Ll}\d])(\p{Lu})/gu;
const SPLIT_UPPER_UPPER_RE = /(\p{Lu})([\p{Lu}][\p{Ll}])/gu;
const SPLIT_REPLACE_VALUE = '$1\0$2';
const DEFAULT_STRIP_REGEXP = /[^\p{L}\d]+/giu;
function split(value) {
    let result = value.trim();
    result = result
        .replace(SPLIT_LOWER_UPPER_RE, SPLIT_REPLACE_VALUE)
        .replace(SPLIT_UPPER_UPPER_RE, SPLIT_REPLACE_VALUE);
    result = result.replace(DEFAULT_STRIP_REGEXP, '\0');
    let start = 0;
    let end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === '\0') {
        start++;
    }
    if (start === end) {
        return [];
    }
    while (result.charAt(end - 1) === '\0') {
        end--;
    }
    return result.slice(start, end).split(/\0/g);
}
